import { styled } from '@mui/system';

const Body = styled('div')({
  width: '100%',
});

export default function Layout({ children }) {
  return <Body>{children}</Body>;
}
